import {useNavigate} from "react-router";
import HeaderItem from "../../components/headerItem/HeaderItem";
import oauth2Figure from "/assets/oauth2-figure.svg?url"
import React from "react";
import {FeatureContainer, FeatureGrid, FeatureKeyTitle} from "../../components/featureKey/FeatureKey.css";
import FeatureKey from "../../components/featureKey/FeatureKey";
import StoreItem from "../../components/storeItem/StoreItem";
import cardLogo from "/assets/api-card-logo.svg?url";
import consultationLogo from "/assets/api-consultation-logo.svg?url"
import {Recommended, SeeAlsoText} from "../../global.css";
import ScrollToTop from "@hooks/scrollToTop";

function Oauth2(){
    const navigate = useNavigate();
    return (
        <div>
            <HeaderItem title={"OAUTH2"}
                        description={"OAuth 2.0 est un protocole d'autorisation permettant à des applications tierces d'obtenir un accès limité aux ressources d'un utilisateur sur un service HTTP, sans exposer les identifiants de l'utilisateur."}
                        imageUrl={oauth2Figure}
                        onClick={() => navigate("/oauth2/documentation")}>
            </HeaderItem>

            <div className={FeatureKeyTitle}>Fonctionnalités Clés</div>

            <div className={FeatureContainer}>
                <div className={FeatureGrid}>
                    <FeatureKey title={"1"} description1={"Authentification"} description2={"des utilisateurs sécurisée"}></FeatureKey>
                    <FeatureKey title={"2"} description1={"Authentification"} description2={"des serveurs via MTLS"}></FeatureKey>
                    <FeatureKey title={"3"} description1={"Authorization"} description2={"code flow & Client credentials"}></FeatureKey>
                    <FeatureKey title={"4"} description1={"Refresh"} description2={"token"}></FeatureKey>
                    <FeatureKey title={"5"} description1={"Token introspection"} description2={"& révocation"}></FeatureKey>
                </div>

                <div className={SeeAlsoText}>Nous vous recommandons aussi....</div>
                <div className={Recommended}>
                    <StoreItem
                        title={"AISP"}
                        description={"Prestataires de services d’information sur les comptes"}
                        onClick={() =>navigate("/aisp")}
                        imageUrl={consultationLogo}>
                    </StoreItem>
                    <StoreItem
                        title={"PISP"}
                        description={"Prestataires de services d’initiation de paiement"}
                        onClick={() => navigate("/pisp")}
                        imageUrl={cardLogo}>
                    </StoreItem>
                </div>

            </div>
            <ScrollToTop />
        </div>
    )
}

export default Oauth2;